import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, TSS_GREEN, stylePropType } from 'tss-core-lib-common';
import mime from 'mime-types';

import FileUploadProgress from './FileUploadProgress';

import fileUploadSrc from '../img/file-upload.svg';

var styles = void 0;

var FileUploadForm = function (_Component) {
  _inherits(FileUploadForm, _Component);

  function FileUploadForm() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, FileUploadForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUploadForm.__proto__ || Object.getPrototypeOf(FileUploadForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      uploading: false,
      // Use keys to force the file input to reset
      inputKey: Math.random().toString(32).substring(2)
    }, _this.handleDragStart = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleDragOver = function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.setState({ over: _this.props.disabled === false });
    }, _this.handleDragLeave = function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.setState({ over: false });
    }, _this.handleDrop = function (event) {
      if (!_this.props.disabled) {
        _this.setState({ over: false });
        event.preventDefault();
        event.stopPropagation();
        try {
          var file = event.dataTransfer.files[0];
          if (_this.props.accept) {
            var acceptedTypes = _this.props.accept.split(/,\s*/);
            var type = mime.lookup(file.name);
            if (acceptedTypes.indexOf(type) === -1) {
              if (_this.props.onError) {
                _this.props.onError({ badFileType: true });
              }
              return;
            }
          }
          _this.handleUpload(file);
        } catch (error) {
          // TODO
        }
      }
    }, _this.handleFileChange = function (event) {
      _this.setState({ inputKey: Math.random().toString(32).substring(2) });
      if (!_this.props.disabled && event.target.files.length) {
        try {
          event.preventDefault();
          event.stopPropagation();
          var file = event.target.files[0];
          if (_this.props.accept) {
            var acceptedTypes = _this.props.accept.split(/,\s*/);
            var type = mime.lookup(file.name);
            if (acceptedTypes.indexOf(type) === -1) {
              if (_this.props.onError) {
                _this.props.onError({ badFileType: true });
              }
              return;
            }
          }
          _this.handleUpload(file);
        } catch (error) {
          // TODO
        }
      }
    }, _this.handleUpload = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.props.disabled) {
                  _context.next = 12;
                  break;
                }

                _context.prev = 1;

                _this.setState({ uploading: true });
                _context.next = 5;
                return _this.props.onUpload(file);

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

              case 9:
                _context.prev = 9;

                _this.setState({ uploading: false });
                return _context.finish(9);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 7, 9, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileUploadForm, [{
    key: 'render',
    value: function render() {
      var inputId = this.props.id + '-file-input';

      return React.createElement(
        'div',
        { className: css(styles.container, this.props.disabled && styles.disabled, this.props.style) },
        React.createElement(
          'form',
          {
            id: this.props.id,
            name: this.props.id,
            className: css(styles.container),
            onDragStart: this.handeDragStart,
            onDragOver: this.handleDragOver,
            onDragEnter: this.handleDragOver,
            onDragLeave: this.handleDragLeave,
            onDragEnd: this.handleDragLeave,
            onDrop: this.handleDrop
          },
          React.createElement(
            'div',
            { className: css(styles.uploadArea, this.state.over && styles.uploadAreaOver) },
            React.createElement(
              'div',
              { className: css(styles.imgContainer) },
              this.state.uploading ? React.createElement(FileUploadProgress, null) : React.createElement('img', { src: this.props.fileUploadImg, alt: 'Drop files here' })
            ),
            React.createElement('input', {
              id: inputId,
              name: inputId,
              key: this.state.inputKey,
              disabled: this.props.disabled,
              className: css(styles.fileInput),
              accept: this.props.accept,
              type: 'file',
              onChange: this.handleFileChange
            }),
            React.createElement(
              'p',
              { className: css(styles.uploadInstructions) },
              this.props.instructions
            ),
            React.createElement(
              'p',
              { className: css(styles.uploadInstructions) },
              React.createElement(FormattedMessage, { id: 'label.or' })
            ),
            React.createElement(
              'label',
              {
                htmlFor: inputId,
                className: css(styles.browseButton, this.props.disabled && styles.disabledBrowseButton)
              },
              React.createElement(FormattedMessage, { id: 'label.browse' })
            )
          )
        )
      );
    }
  }]);

  return FileUploadForm;
}(Component);

FileUploadForm.propTypes = {
  id: PropTypes.string.isRequired,
  style: stylePropType,
  accept: PropTypes.string,
  instructions: PropTypes.string.isRequired,
  fileUploadImg: PropTypes.string,
  disabled: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
  onError: PropTypes.func
};
FileUploadForm.defaultProps = {
  accept: null,
  style: null,
  fileUploadImg: fileUploadSrc,
  disabled: false,
  onError: null
};


styles = StyleSheet.create({
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },

  step: {
    fontSize: '1.2rem',
    color: TSS_DARK_BLUE(0.3),
    textTransform: 'uppercase'
  },

  shipmentIdLabel: {
    color: TSS_DARK_BLUE(0.5)
  },

  uploadAreaContainer: {},

  uploadArea: {
    padding: '3rem 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '3px solid transparent'
  },

  uploadAreaOver: {
    border: '3px dashed ' + TSS_DARK_BLUE(0.2)
  },

  imgContainer: {
    height: '12rem',
    display: 'flex',
    alignItems: 'center'
  },

  fileInput: {
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIindex: -1
  },

  uploadInstructions: {
    margin: '1.6rem 0',
    fontSize: '1.6rem',
    color: '#6F6F6F'
  },

  browseButton: {
    marginTop: '1.6rem',
    backgroundColor: TSS_GREEN,
    color: 'white',
    padding: '0 4rem',
    height: '5.3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: '1.4rem',
    cursor: 'pointer'
  },

  disabledBrowseButton: {
    cursor: 'not-allowed'
  }
});

export default FileUploadForm;